module.exports = __webpack_public_path__ + "img/product-shot_04_loading.3064b335.jpg";